$.eachComponent('.services-prices', function(context) {
    $.datepicker.setDefaults({minDate: new Date()});
});